import packageJson from '../../package.json';

export const environment = {
  production: true,
  useEmulators: false,
  authEmulator: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAuQKgdtTG5ozrG4LxtaZgzxbdfWD_iRLQ',
    authDomain: 'fliko-aaf6e.firebaseapp.com',
    databaseURL: 'https://fliko-prd-common.europe-west1.firebasedatabase.app/',
    projectId: 'fliko-aaf6e',
    storageBucket: 'fliko-aaf6e.appspot.com',
    messagingSenderId: '526827837043',
    appId: '1:526827837043:web:927e18d06b33635548fc06'
  },
  language: 'pl',
  databaseUrlBase: 'https://%NAME%.europe-west1.firebasedatabase.app',
  commonName: 'fliko-prd-common',
  shardNames: ['fliko-prd-shard-luxdom', 'fliko-prd-shard-marvipol', 'fliko-prd-shard-icds-lomianki', 'fliko-prd-shard-other'],
  recaptchaSiteKey: '6Ley1mcsAAAAAIqr-94KNJIjgc4Dh364bypDe7OQ',
  sentryDSN: 'https://11dfdc17d6bb4d299612dd0ddfde2f8e@o4504173958529024.ingest.sentry.io/4504173971767296',
  envName: 'production',
  version: packageJson.version,
  // Replaced during release
  gitSha: '78ce36aed22bbcbf779a58575ca62e469b87081b',
  webPushPublicKey: 'BJ2JUzINmcHVVZ8916XmLZeSAx_v2ywz5vqv73_RmarXYVi156wGGUWYhZFOMPOPDJ6sYr_-OVEQxmh9feAtakE'
};
